import React, { useState, useEffect, useContext } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import Button from '~components/button';
import NotificationsActions from '~redux/notifications';
import { useAuth0 } from '@auth0/auth0-react';

import * as REST from '~services/rest';

import { ChatContext } from '../../context';

const Block = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { discussion, updateDiscussion } = useContext(ChatContext);
  const { getAccessTokenSilently } = useAuth0();

  const [isLoading, setIsLoading] = useState(false);
  const [isBlockedByCurrentUser, setIsBlockedByCurrentUser] = useState(
    discussion.participants.currentUser.hasBlockedChat || false
  );

  const blockChat = async (action) => {
    setIsLoading(true);
    try {
      const token = await getAccessTokenSilently();
      await REST.post({
        name: `chats/${discussion.discussionId}`,
        mockFileName: 'chats/post-block',
        requiresAuthentication: true,
        params: {
          action,
        },
        token,
      });

      const newDiscussion = {
        ...discussion,
        participants: {
          ...discussion.participants,
          currentUser: {
            ...discussion.participants.currentUser,
            hasBlockedChat: action === 'block',
          },
        },
      };

      updateDiscussion(newDiscussion);
      setIsBlockedByCurrentUser(action === 'block');

      dispatch(
        NotificationsActions.addNotification(
          intl.formatMessage({
            id: `containers.chat.options.block.notification.${action}`,
            defaultMessage: 'Chat has been blocked',
          })
        )
      );
    } catch (err) {
      console.log(`Error while performing chat action: ${action}: `, err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      disabled={
        !discussion || !discussion.discussionId || isLoading || discussion.participants.recipient.hasBlockedChat
      }
      onClick={() => blockChat(isBlockedByCurrentUser ? 'unblock' : 'block')}
      isLoading={isLoading}
      className="c-vertical-nav__item c-btn--text c-btn--show-text-with-loader"
      role="menuitem"
    >
      {intl.formatMessage({
        id: `containers.chat.options.block.label.${isBlockedByCurrentUser ? 'unblock' : 'block'}`,
        defaultMessage: 'Block chat',
      })}
    </Button>
  );
};

export default Block;
